import React, { useCallback, useEffect, useState, useContext } from 'react';
import { Handle, Position } from '@xyflow/react';
import styled from 'styled-components';
import {
  Avatar,
  Button,
  Heading,
  Tooltip as SuperopsTooltip,
  TextStyle,
  Badge,
  Popover,
  ActionList,
  Banner,
  DisplayText,
  TextField,
  Modal,
  ButtonGroup,
  Page
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import envConfig from '@nile/home/src/Config/env';
import {
  getTranslatedText,
  COLOR_MAP,
  TEXT_LENGTH,
  COMMON_CONSTANTS,
  VariableInput,
  RunbookNodeActivatorContent,
  reactSelectErrorStyles,
  toast,
  withErrorBoundary,
  AccessControl
} from '@nile/components';
import { injectIntl, FormattedMessage } from 'react-intl';
import AssociateTasks from '@nile/mangifera/src/Containers/ChatContainers/AssociateTasks';
import { GET_ASSET_SCRIPT_LIST_V2 } from '@nile/rmm/src/modules/scripts/Graphql';
import { RMMClient } from '@nile/graphql';
import { useLazyQuery, useQuery } from '@apollo/client';
import { orderBy, forEach, cloneDeep, omit } from 'lodash';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { GET_TICKET_ASSETS } from '@nile/graphql';
import { GET_ASSETS_FILTER } from '@nile/rmm/src/modules/asset-management/Graphql/asset';
import { ALL_ASSET_TYPES } from '@nile/rmm/src/constants';
import { CREATE_USER_ACTION_CONFIG } from '@nile/rmm/src/modules/asset-management/Graphql/asset';

import {
  DropdownIndicator,
  IndicatorSeparator
} from '@nile/components/src/Pebbles/select';
import Select from 'react-select';
import { withRouter } from 'react-router-dom';

function RunScriptsModalContent(props) {
  const { intl, action, ticket, toggleModal, executeEntityFlowAction } = props;

  const flowAction = action?.flowAction;
  let actionValueData = action?.flowAction?.actionValueData.scripts;

  // actionValueData = [
  //   {
  //     script: {
  //       scriptId: '6400342346808832000'
  //     },
  //     assetClass: {
  //       classId: '1'
  //     },
  //     runTimeVars: []
  //   },
  //   {
  //     script: {
  //       scriptId: '7539594199801208832'
  //     },
  //     assetClass: {
  //       classId: '2'
  //     },
  //     runTimeVars: [
  //       {
  //         name: 'Variable',
  //         value: 'status'
  //       }
  //     ]
  //   },
  //   {
  //     script: {
  //       scriptId: '7539594199801208832'
  //     },
  //     assetClass: {
  //       classId: '3'
  //     },
  //     runTimeVars: [
  //       {
  //         name: 'Variable',
  //         value: 'source'
  //       }
  //     ]
  //   }
  // ];

  const [ticketAssets, setTicketAssets] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [respectiveScriptForAsset, setRespectiveScriptForAsset] = useState([]);
  const ticketContext = useContext(TicketContext);
  const [errors, setErrors] = useState(null);
  const [submitActionLoading, setSubmitActionLoading] = useState(false);

  const {
    data: ticketAssetsData,
    loading: ticketAssetsLoading,
    error: ticketAssetsError
  } = useQuery(GET_TICKET_ASSETS, {
    variables: {
      id: ticketContext?.activeTab.data.ticketId
    },
    onCompleted(res) {
      if (res?.getTicket) {
        const selectedAssetsInTicket = res?.getTicket.assets || [];
        // setTicketAssets(selectedAssetsInTicket);
        setTicketAssets((prev) => {
          return [
            ...prev,
            ...selectedAssetsInTicket.map((item) => ({
              value: item.assetId,
              label: item.name
            }))
          ];
        });
      }
    }
  });

  // requester assets

  // const { loading, data, error } = useQuery(GET_ASSETS_FILTER, {
  //   client: RMMClient,
  //   fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
  //   variables: {
  //     viewType: ALL_ASSET_TYPES.ALL_MONITORED_ASSET,
  //     listInfo: {
  //       condition: {
  //         joinOperator: 'OR',
  //         operands: [
  //           {
  //             attribute: 'client.accountId',
  //             operator: 'is',
  //             value: ticket.client.accountId
  //           },
  //           {
  //             attribute: 'owner.userId',
  //             operator: 'is',
  //             value: ticket.requester?.userId
  //           }
  //         ]
  //       }
  //     }
  //   },
  //   onCompleted(res) {
  //     if (res) {
  //       const requesterAssetsInTicket = res?.getAllAssets?.assets || [];
  //       // setTicketAssets(selectedAssetsInTicket);
  //       setTicketAssets((prev) => {
  //         return [
  //           ...prev,
  //           ...requesterAssetsInTicket.map((item) => ({
  //             value: item.assetId,
  //             label: item.name
  //           }))
  //         ];
  //       });
  //     }
  //   }
  // });

  useEffect(() => {
    if (ticketAssetsData) {
      console.log('ticketAssetsData', ticketAssetsData);
    }
  }, [ticketAssetsData]);

  useEffect(() => {
    if (selectedAsset) {
      let ticketAsset = ticketAssetsData?.getTicket?.assets?.find(
        (asset) => asset.assetId === selectedAsset?.value
      );
      if (!ticketAsset) {
        ticketAsset = data?.getAllAssets?.assets?.find(
          (asset) => asset.assetId === selectedAsset?.value
        );
      }

      // find current actionValueData using ticketAsset.assetClass.classId
      const currentActionValue = actionValueData?.find(
        (action) =>
          action.assetClass.classId === ticketAsset?.assetClass?.classId
      );
      if (!currentActionValue) {
        setRespectiveScriptForAsset([]);
        return;
      }
      let actionValue = cloneDeep(currentActionValue);
      actionValue.runTimeVars = currentActionValue.runTimeVars.map((item) => {
        const value = item?.value?.includes('udf')
          ? ticket?.customFields?.[item.value]
          : ticket[item.value];
        return {
          ...item,
          value: value
        };
      });
      setRespectiveScriptForAsset(actionValue);
    }
  }, [selectedAsset]);

  const handleSelectAsset = (val) => {
    setSelectedAsset(val);
  };

  const handleVariableUpdate = (index, value) => {
    console.log('handleVariableUpdate', index, value);

    const updatedScriptArgs = cloneDeep(
      respectiveScriptForAsset?.runTimeVars
    ).map((arg, ind) => {
      if (index === ind) {
        arg.value = value;
      }
      return arg;
    });
    setRespectiveScriptForAsset((prev) => {
      return {
        ...prev,
        runTimeVars: updatedScriptArgs
      };
    });
  };

  const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  useEffect(() => {
    if (respectiveScriptForAsset?.runTimeVars?.length) {
      setIsSaveDisabled(
        respectiveScriptForAsset.runTimeVars.some((arg) => !arg.value)
      );
    } else if (!respectiveScriptForAsset?.script?.scriptId) {
      setIsSaveDisabled(true);
    } else {
      setIsSaveDisabled(false);
    }
  }, [respectiveScriptForAsset]);

  const onSave = () => {
    setSubmitActionLoading(true);

    const variables = {
      input: {
        script: {
          scriptId: respectiveScriptForAsset?.script?.scriptId
        },
        scriptArguments: respectiveScriptForAsset?.runTimeVars.map((arg) => {
          return {
            name: arg.name,
            value: arg.value
          };
        }),
        executionType: 'IMMEDIATE'
      }
    };
    variables.assetId = selectedAsset?.value;

    let actionValueData = {
      scripts: [
        {
          asset: {
            assetId: selectedAsset?.value,
            name: selectedAsset?.label,
            assetClass: {
              classId: respectiveScriptForAsset?.assetClass?.classId
            }
          },
          script: {
            scriptId: respectiveScriptForAsset?.script?.scriptId
          },
          userActionConfig: {
            userActionConfigId: ''
          },
          executionStatus: 'FAILURE'
        }
      ]
    };

    RMMClient.mutate({
      mutation: CREATE_USER_ACTION_CONFIG,
      variables: variables
    })
      .then((res) => {
        if (res) {
          toast('success', 'app.label.triggered');
          toggleModal();

          actionValueData.scripts[0].userActionConfig.userActionConfigId =
            res?.data?.createUserActionConfig?.actionConfigId;
          actionValueData.scripts[0].executionStatus = 'SUCCESS';
          executeEntityFlowAction(flowAction?.actionId, actionValueData);
        }
        setSubmitActionLoading(false);
      })
      .catch((err) => {
        setSubmitActionLoading(false);
        toggleModal();
        executeEntityFlowAction(flowAction?.actionId, actionValueData);
      });
  };

  return (
    <Page
      title={getTranslatedText(intl, 'asset.runscript.title')}
      contentHeight="110px"
      fullWidth
      variant="secondary"
      primaryAction={
        <ButtonGroup spacing="loose">
          <Button
            plainSecondary
            onClick={() => {
              toggleModal();
              setSelectedAsset(null);
            }}
          >
            <FormattedMessage id="mail.unknown.close.button" />
          </Button>

          <Button
            primary
            icon={<SVGIcon name="Save" />}
            onClick={onSave}
            loading={submitActionLoading}
            disabled={isSaveDisabled}
          >
            <FormattedMessage id="asset.runscript.run.title" />
          </Button>
        </ButtonGroup>
      }
    >
      <div className="p2040">
        <AccessControl
          roleToCheck="asset.view"
          render={
            <div className="flex center">
              <span className="mr-10">
                <SVGIcon name="AssetPC" size="lg" />
              </span>
              <Select
                isLoading={ticketAssetsLoading}
                className="select-block w300"
                onChange={(val) => {
                  handleSelectAsset(val);
                }}
                // onMenuOpen={getServiceItems}
                components={{
                  IndicatorSeparator,
                  DropdownIndicator
                }}
                classNamePrefix="value_selector"
                placeholder={getTranslatedText(
                  intl,
                  'admin.policyManagement.hierarchy.selectAsset.placeholder'
                )}
                // formatGroupLabel={formatGroupLabel}
                menuPlacement="auto"
                menuPortalTarget={document.body}
                value={selectedAsset}
                defaultValue={ticketAssets?.[0]}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (base) => ({ ...base, zIndex: 9999 })
                }}
                options={ticketAssets}
              />
              {selectedAsset && (
                <span
                  onClick={() => {
                    props?.history?.push(
                      `/rmm/asset/details/${selectedAsset.value}`
                    );
                  }}
                  className="ml-20"
                >
                  <SVGIcon name="Redirect" size="lg" />
                </span>
              )}
            </div>
          }
        />

        <div className="py-40">
          {respectiveScriptForAsset && respectiveScriptForAsset?.script?.name && (
            <div className="flex center">
              <span className="mr-10">
                <SVGIcon name="Script" size="lg" />
              </span>
              <DisplayText element="h2" weight="SemiBold">
                {respectiveScriptForAsset?.script?.name}
              </DisplayText>
            </div>
          )}

          <div className="flex col">
            {respectiveScriptForAsset &&
              respectiveScriptForAsset?.runTimeVars?.map((variable, index) => (
                <VariableInput
                  intl={intl}
                  variable={variable}
                  index={index}
                  handleVariableUpdate={(idx, val) => {
                    handleVariableUpdate(idx, val, 1);
                  }}
                  error={errors?.scriptArguments?.[0]?.errors?.[index]?.error}
                  isRunScript
                />
              ))}
          </div>
        </div>
      </div>
    </Page>
  );
}

export default withErrorBoundary(
  withRouter(injectIntl(RunScriptsModalContent))
);
